import Route from '@ember/routing/route';
import { service } from '@ember/service';
import throwUnlessTaskDidCancel from 'garaje/utils/throw-unless-task-did-cancel';

export default class LocationOverviewAnalyticsProtectRoute extends Route {
  @service featureFlags;
  @service router;
  @service skinnyLocations;

  beforeModel() {
    // needed for global-analytics ability
    return this.skinnyLocations.loadAllTask.perform().catch(throwUnlessTaskDidCancel);
  }
}
